import JournalEvent from "core/models/journal-event";
import { sortBy } from "./sort";
export default function groupJesByDate(jes, additionalCompute) {
  return jes.sort(sortBy("occurredAt", "desc")).reduce((object, je) => {
    const date = Intl.DateTimeFormat("fr-fr", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).format(je.occurredAt);
    if (!object.hasOwnProperty(date)) {
      object[date] = [];
    }
    object[date].push(je);
    additionalCompute?.(object[date]);
    return object;
  }, {});
}